import {AbstractControl} from '@angular/forms';
import {Base, BaseDTO} from './base';

export interface TenantsFilters {
  search?: string;
}

export interface TenantsDTO extends BaseDTO {
  name: string;
  address: string;
  phone: string;
  city: string;
  time_slot_interval: number;
  max_orderable_products_per_interval: number;
  fidelity_card_target_points: number;
  minimum_order_interval_time: number;
  stripe_public_key: string;
  stripe_private_key: string;
  discount_coupon_id?: string;
  metadata: {};
}
export class Tenants extends Base {
  name: string;
  address: string;
  phone: string;
  city: string;
  timeSlotInterval: number;
  maxOrderableProductsPerInterval: number;
  fidelityCardTargetPoints: number;
  minimumOrderIntervalTime: number;
  stripePublicKey: string;
  stripePrivateKey: string;
  discountCouponId: string;
  metadata: {};

  constructor(source: TenantsDTO) {
    super(source);
    if (source) {
      this.name = source.name;
      this.address = source.address;
      this.phone = source.phone;
      this.city = source.city;
      this.timeSlotInterval = source.time_slot_interval;
      this.maxOrderableProductsPerInterval = source.max_orderable_products_per_interval;
      this.fidelityCardTargetPoints = source.fidelity_card_target_points;
      this.minimumOrderIntervalTime = source.minimum_order_interval_time;
      this.stripePublicKey = source.stripe_public_key;
      this.stripePrivateKey = source.stripe_private_key;
      this.metadata = source.metadata;
    }
  }

  toDTO(): TenantsDTO {
    let result: TenantsDTO = <TenantsDTO>super.toDTO();
    result.name = this.name;
    result.address = this.address;
    result.phone = this.phone;
    result.city = this.city;
    result.time_slot_interval = this.timeSlotInterval;
    result.max_orderable_products_per_interval = this.maxOrderableProductsPerInterval;
    result.fidelity_card_target_points = this.fidelityCardTargetPoints;
    result.minimum_order_interval_time = this.minimumOrderIntervalTime;
    result.stripe_public_key = this.stripePublicKey;
    result.stripe_private_key = this.stripePrivateKey;
    result.discount_coupon_id = this.discountCouponId;
    result.metadata = this.metadata;

    return result;
  }

  static fromFormGroup(formGroup: AbstractControl, original?: Tenants) {
    const formModel = formGroup.value;
    let tenants: Tenants = new Tenants(null);
    tenants.name = formModel.name;
    tenants.address = formModel.address;
    tenants.phone = formModel.phone;
    tenants.city = formModel.city;
    tenants.timeSlotInterval = formModel.timeSlotInterval;
    tenants.maxOrderableProductsPerInterval = formModel.maxOrderableProductsPerInterval;
    tenants.fidelityCardTargetPoints = formModel.fidelityCardTargetPoints;
    tenants.minimumOrderIntervalTime = formModel.minimumOrderIntervalTime;
    tenants.stripePublicKey = formModel.stripePublicKey;
    tenants.stripePrivateKey = formModel.stripePrivateKey;
    tenants.discountCouponId = formModel.discountCouponId;
    tenants.metadata = formModel.metadata;

    if (original) {
      tenants.id = original.id;
    }
    return tenants;
  }


}
